import React from 'react';
import loadable from '@loadable/component';

const PropertyTypesFilter = loadable(
  () =>
    import(
      /* webpackChunkName: "PropertyTypesFilter.loadable" */ 'app/shared/modules/MobileSRP/Header/FilterModules/PropertyTypesFilter/component'
    ),
);

class LoadablePropertyTypesFilter extends React.Component {
  render() {
    return <PropertyTypesFilter {...this.props} />;
  }
}

export default LoadablePropertyTypesFilter;
